import { render, staticRenderFns } from "./TypedPages.vue?vue&type=template&id=ff5ce14e&scoped=true&"
import script from "./TypedPages.vue?vue&type=script&lang=ts&"
export * from "./TypedPages.vue?vue&type=script&lang=ts&"
import style0 from "./TypedPages.vue?vue&type=style&index=0&id=ff5ce14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5ce14e",
  null
  
)

export default component.exports